module.exports = __webpack_public_path__ + "static/img/right-num-row-1.c92e169b.png";